import React, { useEffect } from "react";
import { useLandingPageContext } from "../../hooks/useLandingPageContext";
import { CTA, FAQ, Features, Footer, HowItWorks, Main, Testimonials } from "./components";
import { MobileFooterNavigation } from "../../components";
import { useWidth } from "../../hooks/useMobile";

export default function MobileForms() {
  const { mobileView } = useWidth();
 // State
 const { activePartner, activeService, activePage, mobileFormPageRef } =
   useLandingPageContext();

 // useEffect
 // does: whenever user changes the active form from the sidebar it will move to the top
 useEffect(() => {
   if (mobileFormPageRef.current) {
     mobileFormPageRef.current.scroll({ behavior: "smooth", top: 0 });
   }
 }, [activePage, activeService, activePartner]);

 // component return
 return (
   <section className="mobile-forms">
     <div className="mobile-main-content">
       <div className={`${mobileView ? "" : "snap-container"} scrollable custom-scrollbar`} ref={mobileFormPageRef}>
         <Main />
         {/* <MoreInformation /> */}
         <Features />
         <HowItWorks />
         <Testimonials />
         <FAQ />
         <CTA />
         <Footer />
       </div>
       <MobileFooterNavigation />
     </div>
   </section>
 );
}